<div
  class="library-zone absolute flex flex-col items-center justify-center inset-0"
  [ngClass]="{ dragging: isDraggingFile }"
>
  <img src="/assets/dragndrop.svg" />
  <div translate>MEDIA.ACTIONS.DROP_TRACKS</div>
  <span translate>MEDIA.ACTIONS.DROP_TRACKS_MOUSE</span>
</div>
<div
  class="drop-zone"
  (drop)="onDrop($event)"
  (dragover)="onDragOver($event)"
  [ngClass]="{ dragging: isDraggingFile }"
></div>
